import { pickT } from "@repo/shared";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { T } from "./asset-allocation-config-form.i18n";

type AssetAllocationConfigFormProps = {
  flowLanguage: string;
  showChart: boolean;
  onShowChartChange: (show: boolean) => void;
  showTable: boolean;
  onShowTableChange: (show: boolean) => void;
};

export function AssetAllocationConfigForm({
  flowLanguage,
  showChart,
  onShowChartChange,
  showTable,
  onShowTableChange,
}: AssetAllocationConfigFormProps) {
  const t = pickT(T, flowLanguage);

  return (
    <div className="space-y-4 border rounded-lg p-4 bg-muted/30">
      <div className="space-y-2">
        <Label className="text-base">{t.displayOptions}</Label>
        <p className="text-sm text-muted-foreground">{t.displayDesc}</p>
      </div>

      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="asset-alloc-show-chart" className="text-base">
            {t.showChart}
          </Label>
          <p className="text-sm text-muted-foreground">{t.showChartDesc}</p>
        </div>
        <Switch
          id="asset-alloc-show-chart"
          checked={showChart}
          onCheckedChange={onShowChartChange}
        />
      </div>

      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="asset-alloc-show-table" className="text-base">
            {t.showTable}
          </Label>
          <p className="text-sm text-muted-foreground">{t.showTableDesc}</p>
        </div>
        <Switch
          id="asset-alloc-show-table"
          checked={showTable}
          onCheckedChange={onShowTableChange}
        />
      </div>

      {!showChart && !showTable && (
        <div className="text-sm text-destructive bg-destructive/10 p-3 rounded-md">
          {t.atLeastOneOption}
        </div>
      )}
    </div>
  );
}
